import {
  GET_ACCOUNTTYPE_ABORTED,
  GET_ACCOUNTTYPE_REQUESTED,
  GET_ACCOUNTTYPE_COMPLETED,
  GET_ACCOUNTTYPE_FAILED,
} from './types';
import debug from '../../services/debug';
import isInGroup from '../../services/util/isInGroup';

const getAccountTypeAction = () => async (dispatch, getState) => {
  const { dashboard, session, accounttype } = getState();
  const sessionData = session.get('data');
  const accounttypeData = accounttype.get('data');

  if (accounttypeData?.isDecided ?? null) {
    dispatch({
      type: GET_ACCOUNTTYPE_ABORTED,
    });

    return;
  }
  dispatch({
    type: GET_ACCOUNTTYPE_REQUESTED,
  });

  const dashboardData = dashboard.get('data');
  const planOwners = dashboardData?.planOwners ?? null;

  const payload = {
    isTopLevel:
      isInGroup(sessionData, 'Admin') || isInGroup(sessionData, 'Adviser'),
    isFamily: planOwners && planOwners.length > 1,
    isDecided: !!planOwners,
  };

  try {
    dispatch({
      type: GET_ACCOUNTTYPE_COMPLETED,
      payload,
    });
  } catch (err) {
    debug(GET_ACCOUNTTYPE_FAILED, err);

    dispatch({
      type: GET_ACCOUNTTYPE_FAILED,
      payload: err,
    });
  }
};

export default getAccountTypeAction;
